import React, {
    useContext,
} from "react"

import {
    Context,
} from "../../../Model/Contexts/AppContext"

import "./style.css"
import Spinner from "react-bootstrap/Spinner"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import Container from "react-bootstrap/Container"

export type EMETLLoadingViewProps = {
    showMessage?: string,
}

const EMETLLoadingView = (props?: EMETLLoadingViewProps) => {
    const {
        showMessage,
    } = props

    const {
        loading: {
            message,
        },
    } = useContext(Context)

    return (
        <Container
            className="loadingView d-flex justify-content-center align-items-center"
            style={{
                height: "100vh",
            }}
        >
            <Col className="justify-content-center">
                {message && (
                    <h2
                        className="text-secondary"
                        style={{
                            textAlign: "center",
                            marginBottom: "21px",
                        }}
                    >
                        {showMessage || message}
                    </h2>
                )}
                <Row 
                    className="justify-content-center"
                >
                    <Spinner 
                        animation="grow" 
                        variant="secondary"
                        // size="sm"
                    />
                    <Spinner 
                        animation="grow" 
                        variant="secondary"
                        style={{
                            marginLeft: "8px",
                            marginRight: "8px",
                        }}
                        // size="sm"
                    />
                    <Spinner 
                        animation="grow" 
                        variant="secondary"
                        // size="sm"
                    />
                </Row>
            </Col>
        </Container>
    )
}

export default EMETLLoadingView